import { AuxiliumComponent } from "../auxilium-component";

export default class ListItem extends AuxiliumComponent {
	static observableBooleans = ["hide"];

	parsedCallback() {
		if (this.closest("chip-list")?.hasAttribute("clickable")) {
			this.appendChild(document.createElementWithContents("chip-button", this.childNodes, {
				variation: "body",
				className: "list--button"
			}));
		}
	}
}
